import {getQueryParamsFromHref} from './get-query-params-from-href';

/**
 * Use this to read query parameters with the browser's API.
 *
 * "When should I use this?"
 * - NOT if you're in a react-router dependant route then use `useQueryParams`
 * - DO use this if your feature lives outside react-router
 * - fromHash: set it to true if you want to read query parameters safely in the context of the react router hash routing
 */
export const getQueryParams = (fromHash?: boolean) =>
    getQueryParamsFromHref(fromHash ? window.location.hash : window.location.href);
